import { ListItem, ListItemLink } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { currentUserStore } from '../../../../../CurrentUser/Store';
import History from '../../../../../History';
import { T } from '../../../../../Translations';
import { MenuItemContent, menuItems } from '../../Types';

export interface Props {
  onClick: () => void;
}

function MainListMenu({ onClick }: Props) {
  const handleClick = (href: string) => () => {
    onClick();
    History.push(href);
  };

  return (
    <>
      {menuItems(currentUserStore.links).map((mi: MenuItemContent) => (
        <ListItem
          key={mi.rel}
          role="menuitem"
          aria-label={mi.content}
          className="p-0"
          onClick={handleClick(mi.to)}
        >
          <ListItemLink
            data-testid={mi.rel}
            render={({ className, activeClassName }) => (
              <NavLink
                to={mi.to}
                tabIndex={-1}
                className={className}
                activeClassName={activeClassName}
                data-testid={mi.rel}
                exact={mi.exact}
                aria-label={mi.content}
              >
                <T kind={mi.content} />
              </NavLink>
            )}
          />
        </ListItem>
      ))}
    </>
  );
}

export default observer(MainListMenu);
